// extracted by mini-css-extract-plugin
export default {"status":"ArtistChangeOrderStatus_status__Uk5Zz","card":"ArtistChangeOrderStatus_card__QMWM3"};